import { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { login, triggerAlert } from "../../utils/commonFunctions";
import { captchrefresh, loginCustomer, otpVerification, resendOtp } from "../../utils/APIClient";
import { emailValidation, passwordValidations, trimValidation } from "../../utils/Constants";
import { FaEye, FaEyeSlash } from 'react-icons/fa'; // FontAwesome icons
import SkeletonLoader from "../../Components/Skelton";
import Loader from "../../Components/Loader";

export default function Login() {
    const {
        register,
        handleSubmit,
        formState: { errors },
        watch,reset,
        setValue
    } = useForm();
    const [isLoading, setIsLoading] = useState(false);
    const [capchaData, setCaptchaData] = useState({});
    const navigate = useNavigate();
    const [showPassword, setShowPassword] = useState(false);

    const otp_expire_time = 60;
    const [isTimerActive, setIsTimerActive] = useState(false);
    const [timeLeft, setTimeLeft] = useState(otp_expire_time);
    const [isOtpExpired, setIsOtpExpired] = useState(false);
    const [showOtpScreen, setShowOtpScreen] = useState(false);
    const [errorOTP, setErrorOTP] = useState('');
    const [userDetailsOtp, setUserDetailsOtp] = useState({});
    const [isSubmitting, setIsSubmitting] = useState(false); // Changed from isLoading to isSubmitting
    const [otp, setOtp] = useState(new Array(6).fill(""));

        const [userCaptchaInput, setUserCaptchaInput] = useState("");

    const [rememberMe, setRememberMe] = useState(false);
    const emailInputRef = useRef("");
    const passwordref = useRef("");


    const otpInputsRef = useRef([]);
    //Helper functions
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const loginUser = async (data) => {
        // if (data.captcha?.trim() === capchaData.captcha_text) {
        if (data.username) data.username = data.username.trim();
        if (data.password) data.password = data.password.trim();
        const { capcha, ...remainingData } = data;
        setIsLoading(true);
        // API call to signup
        try {

            const response = await loginCustomer(remainingData);
            const respdata = response.data;
            if (respdata.error_code === 200) {
                const { access, user } = respdata.results;
                const coookie_data = {
                    token: access,
                    user_id: user.id,
                    email: user.email,
                    full_name: respdata.fullname,
                    company_name: respdata.company_name,
                }
                // login(coookie_data)
                // setTimeout(() => {
                //     navigate('/dashboard');
                // }, 2000);

                // triggerAlert('success', '', respdata.message || 'Successfully logged in');

                 
                    login(coookie_data);
                    setTimeout(() => {
                        navigate("/dashboard");
                    }, 1500);
                 

            }

        } catch (error) {
            console.log('Login Error:', error);
            triggerAlert('error', '', error?.response?.data?.results.detail || 'Something went wrong');
            console.error(error)
            setIsLoading(false);
        } finally {
            setIsLoading(false);
        }
        // } else {
        //     triggerAlert('error', '', 'Invalid Captcha');
        // }

    };
    const generateCaptcha = async () => {
        try {
            const response = await captchrefresh();
            if (response.status === 200) {
                const data = await response.data;
                setCaptchaData({
                    captcha_text: data.captcha_text,
                    image_data: `data:image/png;base64,${data.image_data}`
                });
            }
        } catch (error) {
            console.error(error);
        }
    }
    useEffect(() => {
        generateCaptcha();
        // Load saved email and password from localStorage on component mount
        const savedEmail = localStorage.getItem("callingoRememberMe");
    const savedPassword = localStorage.getItem("callingoRememberMePassword");

    if (savedEmail) {
        setValue("username", savedEmail);
        setRememberMe(true);
    }

    if (savedPassword) {
        setValue("password", savedPassword);
    }
    }, []);

    // Save or remove email and password from localStorage based on Remember Me checkbox
    useEffect(() => {
    const email = watch("username");
    const password = watch("password");

    if (rememberMe && email) {
        localStorage.setItem("callingoRememberMe", email.trim());
    } else if (!rememberMe) {
        localStorage.removeItem("callingoRememberMe");
    }

    if (rememberMe && password) {
        localStorage.setItem("callingoRememberMePassword", password);
    } else if (!rememberMe) {
        localStorage.removeItem("callingoRememberMePassword");
    }
}, [rememberMe, watch("username"), watch("password")]);

    const otpVerify = async (e) => {
        //  setIsLoading(true);
        e.preventDefault();
        const isEmpty = otp.some((val) => val === '');
        if (isEmpty) {
            setErrorOTP('All fields are required');
            return;
        }
        setIsSubmitting(true);
        setErrorOTP('');
        const combinedOtp = otp.join('');
        const api_input = {
            two_fa_code: combinedOtp,
            username: userDetailsOtp.email,
        };
        try {
            const response = await otpVerification(api_input);
            const response_data = response.data;
            if (response_data.error_code === 200) {
              
                login({
                    token: userDetailsOtp?.token,
                    email: userDetailsOtp?.email,
                    user_id: userDetailsOtp?.user_id,
                    company_name: userDetailsOtp?.company_name,
                    full_name: userDetailsOtp?.full_name,
                });
                navigate("/dashboard");
            } else {
                setErrorOTP('Invalid OTP.');
                triggerAlert("info", "", "Invalid OTP.");
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.message || 'An error occurred while verifying OTP.';
            console.error('OTP Verification Error:', error, errorMessage);
            setErrorOTP(errorMessage);
            triggerAlert("info", "", errorMessage);
        } finally {
            setIsSubmitting(false);
             setIsLoading(false);
        }
    };

        const handleInputChange = (index, value) => {
        if (!/^[0-9]?$/.test(value)) return;

        const newOtp = [...otp];
        newOtp[index] = value;
        setOtp(newOtp);

        if (value && index < otp.length - 1) {
            otpInputsRef.current[index + 1]?.focus();
        }
    };

    const clearOtpInputs = () => {
        setOtp(Array(6).fill(''));
        otpInputsRef.current.forEach(input => {
            if (input) input.value = '';
        });
    };

        const handleKeyDown = (e, index) => {
        if (e.key === 'Backspace' && !otp[index] && index > 0) {
            otpInputsRef.current[index - 1].focus();
            const newOtp = [...otp];
            newOtp[index - 1] = '';
            setOtp(newOtp);
        }
    };

        const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            otpVerify(e);
        }
    };

        const handleLoginOtp = () => {
        setIsTimerActive(false);
        setTimeLeft(otp_expire_time);
        setIsOtpExpired(false);
        setErrorOTP('');
        clearOtpInputs();
        setShowOtpScreen(false);
        generateCaptcha();
        reset();
        setUserCaptchaInput("");
    };

        const formatTime = (time) => {
        const minutes = Math.floor(time / 60);
        const seconds = time % 60;
        return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    };

        const handleResendOtp = async () => {
        clearOtpInputs();
        setIsSubmitting(true);
        const api_input = {
            username: userDetailsOtp.email,
        };
        try {
            const response = await resendOtp(api_input);
            if (response.status === 200) {
                triggerAlert("success", "Success", `OTP has been sent to your email ${userDetailsOtp?.email}`);
                setIsTimerActive(false);
                setTimeLeft(otp_expire_time);
                setIsOtpExpired(false);
                setIsTimerActive(true);
            } else {
                triggerAlert("info", "", "Unable to send the OTP.");
            }
        } catch (error) {
            console.error(error);
            triggerAlert("info", "", "Unable to send the OTP.");
        } finally {
            setIsSubmitting(false);
        }
    };


    useEffect(() => {
        let timer;
        if (isTimerActive && !isOtpExpired) {
            timer = setInterval(() => {
                setTimeLeft(prevTime => {
                    if (prevTime <= 1) {
                        clearInterval(timer);
                        setIsTimerActive(false);
                        setIsOtpExpired(true);
                        return 0;
                    }
                    return prevTime - 1;
                });
            }, 1000);
        }
        return () => clearInterval(timer);
    }, [isTimerActive, isOtpExpired]);


    if (isLoading) {
        return <SkeletonLoader type="login" />;
    }
    return (
        <div className="auth-fluid">
            {/*Auth fluid left content */}
            <div className="auth-fluid-form-box">
                <div className="card-body d-flex flex-column h-100 gap-3">
                    {/* Logo */}
                    <div className="auth-brand text-center text-lg-start">
                        <a href="/" className="logo-dark">
                            <span><img src="assets/images/logo.png" alt="dark logo" height={70} /></span>
                        </a>
                        <a href="/" className="logo-light">
                            <span><img src="assets/images/logo.png" alt="logo" height={60} /></span>
                        </a>
                    </div>
                    <div className="my-auto">
                        {/* title*/}
                        <h3 className="mt-0">{showOtpScreen ? 'Two-Factor Authentication' : 'Sign In'}</h3>
                        <p className=" mb-4">{showOtpScreen ? 'Please enter the code to verify your account':''}</p>
                        
                        {/* form */}
                        {!showOtpScreen ? <form id="login-form" onSubmit={handleSubmit(loginUser)}>
                            <div className="mb-3">
                                <label htmlFor="emailaddress" className="form-label">Email address<span className="text-danger"> *</span></label>
                                <input
                                    type="email"
                                    id="emailaddress"
                                    name="username"
                                    {...register("username", { 
                                        required: "Email is required", 
                                        pattern: {
                                            value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                            message: "Please enter a valid email address"
                                        },
                                        maxLength: {
                                            value: 150,
                                            message: "Email cannot exceed 150 characters"
                                        }
                                    })}
                                    className="form-control"
                                    placeholder="Enter your email address"
                                    autoComplete='off'
                                    defaultValue={emailInputRef.current}
                                />
                                {errors.username && <small className="text-danger d-block mb-2">{errors.username.message}</small>}
                            </div>
                            <div className="mb-3 ">
                                <Link to="/forgot-password" className="text-warning float-end">
                                    <small>Forgot your password?</small>
                                </Link>

                                <label htmlFor="password" className="form-label">Password<span className="text-danger"> *</span></label>

                                <div className="position-relative">
                                    <input
                                    type={showPassword ? "text" : "password"}
                                    id="password"
                                    name="password"
                                    {...register("password", {
                                        required: "Password is required",
                                        minLength: {
                                            value: 6,
                                            message: "Password must be at least 6 characters long"
                                        },
                                        maxLength: {
                                            value: 15,
                                            message: "Password cannot exceed 15 characters"
                                        },
                                        pattern: {
                                            value: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]).{6,}$/,
                                            message: "Password must contain uppercase, lowercase, number, and special character"
                                        }
                                    })}
                                    className="form-control pe-5"
                                    placeholder="Enter your password"
                                    autoComplete="new-password"
                                    defaultValue={passwordref.current}

                                />
                                  <span
                                    onClick={togglePasswordVisibility}
                                    style={{
                                        position: "absolute",
                                        right: "15px",
                                        top: "50%", // slightly below the label
                                        transform: "translateY(-50%)",
                                        cursor: "pointer",
                                        fontSize: "18px",
                                        color: "#6c757d",
                                    }}
                                >
                                    {showPassword ? <FaEye /> : <FaEyeSlash />}
                                </span>
                                </div>

                                {errors.password && (
                                    <small className="text-danger d-block mt-1">{errors.password.message}</small>
                                )}

                              
                            </div>

                            {/* <div className="d-flex justify-content-between mb-3">
                              
                                <input
                                    type="text"
                                    name='captcha'
                                    {...register("captcha", { required: "Captcha is required", ...trimValidation("It cannot be just spaces") },)}
                                    className="form-control"
                                    placeholder="Verification Code"
                                />
                                <img
                                    id="vimg"
                                    alt="captcha"
                                    src={capchaData?.image_data}
                                    className='ms-2'
                                    align="absmiddle"
                                    style={{
                                        width: "130%",
                                        height: "auto",
                                        maxWidth: "109px",
                                        float: "left",
                                        borderRadius: "3px"
                                    }}
                                />
                                <span
                                    className="m-1"
                                    id="refreshimage"
                                    style={{ cursor: "pointer" }}
                                >
                                    <svg
                                        onClick={generateCaptcha}
                                        className="icon"
                                        height="30"
                                        viewBox="0 0 24 24"
                                        width="38"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            fill="grey"
                                            d="m23.8995816 10.3992354c0 .1000066-.1004184.1000066-.1004184.2000132 0 0 0 .1000066-.1004184.1000066-.1004184.1000066-.2008369.2000132-.3012553.2000132-.1004184.1000066-.3012552.1000066-.4016736.1000066h-6.0251046c-.6025105 0-1.0041841-.4000264-1.0041841-1.00006592 0-.60003954.4016736-1.00006591 1.0041841-1.00006591h3.5146443l-2.8117154-2.60017136c-.9037657-.90005932-1.9079498-1.50009886-3.0125523-1.90012523-2.0083682-.70004614-4.2175733-.60003954-6.12552305.30001977-2.0083682.90005932-3.41422594 2.50016478-4.11715481 4.5002966-.20083682.50003295-.80334728.80005275-1.30543933.60003954-.50209205-.10000659-.80334728-.70004613-.60251046-1.20007909.90376569-2.60017136 2.71129707-4.60030318 5.12133891-5.70037568 2.41004184-1.20007909 5.12133894-1.30008569 7.63179914-.40002637 1.4058578.50003296 2.7112971 1.30008569 3.7154812 2.40015819l3.0125523 2.70017795v-3.70024386c0-.60003955.4016736-1.00006591 1.0041841-1.00006591s1.0041841.40002636 1.0041841 1.00006591v6.00039545.10000662c0 .1000066 0 .2000132-.1004184.3000197zm-3.1129707 3.7002439c-.5020921-.2000132-1.1046025.1000066-1.3054394.6000396-.4016736 1.1000725-1.0041841 2.200145-1.9079497 3.0001977-1.4058578 1.5000989-3.5146444 2.3001516-5.623431 2.3001516-2.10878662 0-4.11715482-.8000527-5.72384938-2.4001582l-2.81171548-2.6001714h3.51464435c.60251046 0 1.0041841-.4000263 1.0041841-1.0000659 0-.6000395-.40167364-1.0000659-1.0041841-1.0000659h-6.0251046c-.10041841 0-.10041841 0-.20083682 0s-.10041841 0-.20083682 0c0 0-.10041841 0-.10041841.1000066-.10041841 0-.20083682.1000066-.20083682.2000132s0 .1000066-.10041841.1000066c0 .1000066-.10041841.1000066-.10041841.2000132v.2000131.1000066 6.0003955c0 .6000395.40167364 1.0000659 1.0041841 1.0000659s1.0041841-.4000264 1.0041841-1.0000659v-3.7002439l2.91213389 2.8001846c1.80753138 2.0001318 4.31799163 3.0001977 7.02928871 3.0001977 2.7112971 0 5.2217573-1.0000659 7.1297071-2.9001911 1.0041841-1.0000659 1.9079498-2.3001516 2.4100418-3.7002439.1004185-.6000395-.2008368-1.2000791-.7029288-1.3000857z"
                                            transform=""
                                        ></path>
                                    </svg>
                                </span>
                            </div> */}
                            <div className="d-grid mb-0 text-center">
                                <button className="btn btn-success" type="submit"><i className="ri-login-box-line" disabled={isLoading} />   {isLoading ? 'Logging In...' : 'Log In'}</button>
                            </div>

                            <div className="d-flex justify-content-between align-items-center mt-2">
                                <div className="form-check">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="rememberMe"
                                        style={{cursor:'pointer'}}
                                        checked={rememberMe}
                                        onChange={(e) => setRememberMe(e.target.checked)}
                                    />
                                    <label className="form-check-label" style={{cursor:'pointer'}} htmlFor="rememberMe" >
                                        Remember Me
                                    </label>
                                </div>
                            </div>
                            {/* social*/}
                            <div className="text-center mt-4">
                                <p className=" fs-16">Sign in with</p>
                                <ul className="social-list list-inline mt-3">
                                    <li className="list-inline-item">
                                        <a href="#" className="social-list-item border-primary text-primary"><i className="ri-facebook-circle-fill" /></a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="#" className="social-list-item border-danger text-danger"><i className="ri-google-fill" /></a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="#" className="social-list-item border-info text-info"><i className="ri-twitter-fill" /></a>
                                    </li>
                                    <li className="list-inline-item">
                                        <a href="#" className="social-list-item border-secondary text-secondary"><i className="ri-github-fill" /></a>
                                    </li>
                                </ul>
                            </div>
                        </form> : 
                        <div className='d-flex flex-column justify-content-center align-items-center'>
                                            <div className='text-center'>
                                                <span className='text-dark'>A code has been sent to </span>
                                                <span className="fw-semibold text-dark">{userDetailsOtp?.email ? userDetailsOtp?.email : 'your mail'}</span>
                                            </div>
                                            <div id="otp" className="inputs d-flex flex-row justify-content-center mt-2">
                                                {otp.map((digit, index) => (
                                                    <input
                                                        key={index}
                                                        className="m-2 text-center form-control rounded text-dark"
                                                        type="text"
                                                        maxLength="1"
                                                        value={digit}
                                                        onChange={(e) => handleInputChange(index, e.target.value)}
                                                        onKeyDown={(e) => handleKeyDown(e, index)}
                                                        onKeyPress={handleKeyPress}

                                                        ref={(el) => (otpInputsRef.current[index] = el)}
                                                        style={{ width: "40px" }}
                                                    />
                                                ))}
                                            </div>
                                            {errorOTP && <p className="text-center text-danger">{errorOTP}</p>}
                                            {!isOtpExpired && (
                                                <div className="text-center mt-4">
                                                    <button
                                                        className="btn btn-md btn-success px-4 validate"
                                                        onClick={otpVerify}
                                                        disabled={isOtpExpired || isSubmitting}
                                                    >
                                                        {isSubmitting ? 'Verifying...' : 'Verify'}
                                                    </button>
                                                </div>
                                            )}
                                            {isTimerActive ? (
                                                <p className={`timer mb-0 font-size-18 mt-4 text-success text-center`}>
                                                    Time left <strong className={`${timeLeft <= 30 ? 'text-danger' : 'text-success'}`}>{formatTime(timeLeft)}</strong> seconds
                                                </p>
                                            ) : isOtpExpired ? (
                                                <p className="timer text-danger mb-0 font-size-18 mt-4">OTP expired. Resend now to continue.</p>
                                            ) : null}
                                            {isOtpExpired && (
                                                <p className="resend text-muted mb-0 font-size-18 mt-4">
                                                    Didn&apos;t receive authentication code?{" "}
                                                    {isSubmitting ? (
                                                        <div className="d-flex justify-content-center align-items-center">
                                                            <Loader />
                                                        </div>
                                                    ) : (
                                                        <a
                                                            type="button"
                                                            href="#/"
                                                            className="text-primary text-decoration-underline fw-semibold"
                                                            onClick={handleResendOtp}
                                                        >
                                                            Resend
                                                        </a>
                                                    )}
                                                </p>
                                            )}
                                            <div className="text-center mt-3 d-flex align-items-baseline justify-content-center">
                                                <i className="fa fa-angle-double-left me-1" />
                                                <p role="button" className="text-decoration-underline fonst-size-20 fw-semibold" onClick={handleLoginOtp}>
                                                    Back to Login
                                                </p>
                                            </div>
                                        </div>
                        
                        }
                        {/* end form*/}
                    </div>
                    {/* Footer*/}
                    <footer className="footer footer-alt">
                        <p className=" ">Don't have an account? <Link to="/signup" className="text-warning ms-1"><b>Sign Up</b></Link></p>
                    </footer>
                </div> {/* end .card-body */}
            </div>
            {/* end auth-fluid-form-box*/}
            {/* Auth fluid right content */}
            <div className="auth-fluid-right text-center">
                <div className="auth-user-testimonial">
                    <div id="carouselExampleFade" className="carousel slide carousel-fade" data-bs-ride="carousel">
                        <div className="carousel-inner">
                            <div className="carousel-item">
                                <h2 className="mb-2 text-info">Seamless Voice Integration with Callingo</h2>
                                <p className="lead"><i className="ri-double-quotes-l" />Using Callingo, I effortlessly built a Shopify app to recover abandoned checkouts, avoiding the usual hassle of integrating multiple APIs and dealing with latency or unnatural voice interruptions.
                                </p>
                                <p>
                                    - Charlie Stigler(Founder, SpeakSage)
                                </p>
                            </div>
                            <div className="carousel-item">
                                <h2 className="mb-2 text-info">Relevance AI</h2>
                                <p className="lead"><i className="ri-double-quotes-l" />built an AI sales that do Cold Call &amp; Whatsapp followup - powered by callingo
                                </p>
                                <p>
                                    - Kwindla Kramer
                                </p>
                            </div>
                            <div className="carousel-item active">
                                <h2 className="mb-2 text-info">Feature Availability!</h2>
                                <p className="lead"><i className="ri-double-quotes-l" /> This is a great product, helped us a lot and very quick to work with and implement.
                                </p>
                                <p>
                                    - trydaily
                                </p>
                            </div>
                        </div>
                    </div>
                </div> {/* end auth-user-testimonial*/}
            </div>
            {/* end Auth fluid right content */}
        </div>

    )
}
